import { Hero } from "@/components/Hero";
import { Features } from "@/components/Features";
import { Stats } from "@/components/Stats";
import { Pricing } from "@/components/Pricing";
import { Footer } from "@/components/Footer";
import { Navigation } from "@/components/Navigation";
import { useSession } from "@/hooks/useSession";

const Index = () => {
  const { session, isSessionLoading } = useSession();
  const isAuthenticated = !isSessionLoading && !!session;

  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <Features />
      <Stats />
      {!isAuthenticated && <Pricing />}
      <Footer />
    </div>
  );
};

export default Index;